import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { DIALOG_DATA, DialogRef } from '../../';
import { SuiButtonComponent, SuiDialogComponent } from '@stride-ui/components';
import { TranslateModule } from '@ngx-translate/core';

export interface ConfirmationDialogData {
  title: string;
  text: string;
  textParams?: Record<string, unknown>;
  confirmLabel?: string;
  destructive?: boolean;
}

@Component({
  selector: 'tnq-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CdkTrapFocus,
    SuiButtonComponent,
    SuiDialogComponent,
    TranslateModule,
  ],
})
export class ConfirmationDialogComponent {
  data = inject<ConfirmationDialogData>(DIALOG_DATA);
  private dialogRef = inject(DialogRef);

  dismiss() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
